import React from 'react';
import CallDashboardContactAvailabilityForm from 'components/molecules/call-dashboard/forms/contact-availability';
import { usePatientInfo } from 'infrastructure/hooks/patient/use-patient-info';

interface IProps {
  patientGuid: string;
}

const CallDashboardContactAvailabilityTab: React.FC<IProps> = (props) => {
  const { patientGuid } = props;

  const { patientInfo, loading } = usePatientInfo({
    patientGuid,
  });

  return (
    <div>
      <CallDashboardContactAvailabilityForm
        loading={loading}
        patientGuid={patientGuid}
        timezone={patientInfo?.loginInfo?.timezone!}
      />
    </div>
  );
};

export default CallDashboardContactAvailabilityTab;
